import { Card, CardActions } from '@material-ui/core';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  padding: 18px 27px 18px 27px;
  border-bottom: groove;
  height: 950px;
  overflow: auto;
  @media (max-width: 450px) {
    width: 365px;
    padding: 9px 14px 9px 14px;
  }
`;

export const CardHeader = styled.p`
  font-family: EB Garamond;
  font-size: 34px;
  font-style: italic;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 0.25px;
  text-align: left;
  margin: 0;
`;

export const CardBody = styled.section`
  margin-bottom: 30px;
  margin-top: 0;
  font-family: EB Garamond;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
  min-height: 50px;
`;

export const QuestionTypography = styled.p`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 32px;
  text-transform: uppercase;
  margin-bottom: 0;
`;

export const SubQuestionTypography = styled.p`
  font-family: EB Garamond;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;
export const CardActionsContainer = styled(CardActions)`
  display: flex;
  justify-content: space-between;
`;
